import PropTypes from "prop-types";
import {useParams} from "react-router-dom";
import Content from "components/helpers/action-text/content";
import Loading from "components/pages/loading";
import {isBlankHTML} from "lib/ext/string";
import useUnknown from "lib/hooks/use-unknown";
import Links from "./links";

function Question({id = null}) {
  const params = useParams();
  const unknown = useUnknown(id || params.id);

  if(!unknown) { return <Loading />; }

  const questions = unknown.questions.map(({content}) => content)
    .filter((html) => !isBlankHTML(html));
  const question = params.index ? questions[+params.index - 1] : questions[0];

  return (
    <div className="max-w-screen-md mx-auto">
      <h1>Question</h1>
      <div className="custom-html">
        <Content className="mb-4" html={question || "There is no question yet for this unknown"} />
      </div>
      <Links />
    </div>
  );
}

Question.propTypes = {id: PropTypes.number};

export default Question;
